import { render, staticRenderFns } from "./businessTranslation.vue?vue&type=template&id=8652d298&scoped=true&"
import script from "./businessTranslation.vue?vue&type=script&lang=js&"
export * from "./businessTranslation.vue?vue&type=script&lang=js&"
import style0 from "./businessTranslation.vue?vue&type=style&index=0&id=8652d298&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8652d298",
  null
  
)

export default component.exports